import { LockOpen as LockOpenIcon } from '@mui/icons-material';

export default function LockOpen(): JSX.Element {
  return <LockOpenIcon fontSize="inherit" />;
}
